'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { TableCell as TD } from 'foundations-components/transitional/components/Table';
import { getCellBlockSize, convertToTextAlign } from '../../tableUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const dotUseMapping = {
  LOW: 'danger',
  FAIR: 'warning',
  GOOD: 'success',
  EXCELLENT: 'success'
};
export default function SenderScoreCell(renderArgs) {
  const {
    column: {
      align
    },
    value,
    isMobile
  } = renderArgs;
  const textAlign = convertToTextAlign(align);
  if (value === 'UNKNOWN') {
    return /*#__PURE__*/_jsxs(TD, {
      textAlign: textAlign,
      blockSize: getCellBlockSize(isMobile),
      "data-test-id": "sender-score-cell-unavailable",
      children: ["\u2014", ' ', /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-data.properties.sequence-sender-score.senderScoreUnavailable"
        }),
        size: "100",
        alignWithText: true
      })]
    });
  }
  return /*#__PURE__*/_jsxs(TD, {
    textAlign: textAlign,
    blockSize: getCellBlockSize(isMobile),
    "data-test-id": "sender-score-cell",
    children: [/*#__PURE__*/_jsx(StatusDot, {
      "data-test-id": "sender-score-cell-dot",
      use: dotUseMapping[value]
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reporting-data.properties.sequence-sender-score.senderScoreValue.${value}`
    })]
  });
}